import { Layout, Menu } from 'antd';
import Sider from 'antd/es/layout/Sider';
import React, { useEffect, useState } from 'react';
import { GrUserWorker } from 'react-icons/gr';
import { BsFillPersonCheckFill } from 'react-icons/bs';
import { DashboardOutlined, BellOutlined, NotificationOutlined, HomeOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import { Content, Header } from 'antd/es/layout/layout';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const screens = useBreakpoint();
  
 
  const token = sessionStorage.getItem('token');
  const userRole = sessionStorage.getItem('role');

  useEffect(() => {
    setCollapsed(screens.xs);
  }, [screens]);

  useEffect(() => {
    if (userRole === "asistan" && !window.location.pathname.startsWith('/admin/support')) {
      window.location.href = "/admin/support";
    }
  }, [userRole]);

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('role'); 
    navigate("/login");    
  };

  const menuItems = userRole === "asistan"
    ? [
        {
          key: '2',
          icon: <BellOutlined />,
          label: 'Destek Talepleri',
          path: "/admin/support",
          children: [
            {
              key: '3',
              label: <>Bekleyen Talepler</>,
              path: "/admin/support",
              onClick: () => navigate("/admin/support")
            },
            {
              key: '4',
              label: <>Tamamlanan Talepler</>,
              path: "/admin/support/completed",
              onClick: () => navigate("/admin/support/completed") 
            },
          ]
        },
        {
          key: '5',
          label: <>Anasayfaya Git</>,
          icon: <HomeOutlined />,
          path: "/",
          onClick: () => window.location.href = "/"
        },
        {
          key: '6',
          label: <>Çıkış Yap</>,
          icon: <LogoutOutlined />,
          onClick: handleLogout
        }
      ]
    : [
        {
          key: '1',
          icon: <DashboardOutlined />,
          label: 'İstatistikler',
          path: "/admin/",
          onClick: () => navigate("/admin/") 
        },
        {
          key: '2',
          icon: <BellOutlined />,
          label: 'Destek Talepleri',
          path: "/admin/support",
          children: [
            {
              key: '3',
              label: <>Bekleyen Talepler</>,
              path: "/admin/support",
              onClick: () => navigate("/admin/support")
            },
            {
              key: '4',
              label: <>Tamamlanan Talepler</>,
              path: "/admin/support/completed",
              onClick: () =>navigate("/admin/support/completed") 
            }
          ]
        },
        {
          key: '5',
          icon: <GrUserWorker />,
          label: 'Çalışanlar',
          path: '/admin/employess',
          children: [
            { key: '6', path: '/admin/employess', label: 'Çalışan Listesi', onClick: () =>  navigate("/admin/employess")},
            { key: '7', path: '/admin/employess/create', label: 'Yeni Çalışan Oluştur', onClick: () =>navigate("/admin/employess/create")}
          ]
        },
        {
          key: '8',
          icon: <BsFillPersonCheckFill />,
          label: 'Yöneticiler',
          path: '/admin/manager',
          children: [
            { key: '9', path: '/admin/manager', label: 'Yönetim Kurulu Listesi', onClick: () => navigate("/admin/manager") },
            { key: '10', path: '/admin/audit', label: 'Denetim Kurulu Listesi', onClick: () =>  navigate("/admin/audit") },
            { key: '11', path: '/admin/unit', label: 'Birim Sorumlusu', onClick: () =>  navigate("/admin/unit")},
            { key: '12', path: '/admin/manager/create', label: 'Yeni Yönetici Oluştur', onClick: () => navigate("/admin/manager/create")}
          ]
        },
        {
          key: '13',
          icon: <NotificationOutlined />,
          label: 'Duyurular',
          path: '/admin/notice',
          children: [
            { key: '14', path: '/admin/notice', label: 'Duyuru Listesi', onClick: () => navigate("/admin/notice")},
            { key: '15', path: '/admin/notice/create', label: 'Duyuru Oluştur', onClick: () => navigate("/admin/notice/create")},
          ]
        },
        {
          key: '16',
          label: <>Anasayfaya Git</>,
          icon: <HomeOutlined />,
          path: "/",
          onClick: () => window.location.href = "/"
        },
        {
          key: '17',
          label: <>Çıkış Yap</>,
          icon: <LogoutOutlined />,
          onClick: handleLogout
        }
      ];

  if (token) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          collapsible
          collapsed={collapsed}
          collapsedWidth={screens.xs ? 80 : 200}
          breakpoint="md"
          onCollapse={setCollapsed}
        >
          <Menu mode="vertical" style={{ height: '100%' }} items={menuItems} />
        </Sider>
        <Layout>
          <Header style={{ display: 'flex', justifyContent: 'space-between', color: '#fff', padding: '0 20px' }}>
            <h2>Admin Paneli</h2>
          </Header>
          <Content style={{ padding: 24, minHeight: 360 }} className="site-layout-background">
            {children}
          </Content>
        </Layout>
      </Layout>
    );
  } else {
    return (window.location.href = "/login");
  }
};

export default AdminLayout;
